import React from 'react';
import ReactDOM from "react-dom";
import ModalMenuWrapper from "./ModalMenuWrapper";

const ModalMenu = ({isOpen, setIsOpen}) => {
    return isOpen ? ReactDOM.createPortal(<ModalMenuWrapper setIsOpen={setIsOpen}/>, document.getElementById('modal-menu')) : '';
};

export default ModalMenu;
